import { Injectable } from '@angular/core';
import { Observable, Subject } from "rxjs";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { fuseConfig } from '../../fuse-config';
@Injectable({
    providedIn: 'root'
})
export class OwnerService {
    private subject;
    public unit = null;
    public selectedUnit = null;
    public fromDashboard = false;
    constructor(private http: HttpClient) {
      this.subject = new Subject();
    }

    subscribe(next, error?, complete?): any {
        return this.subject.subscribe(next, error, complete);
    }
    
    selectUnit(unit): any {
        this.unit = unit;
        this.subject.next(unit);
    }

    getUnitHouses(): Observable<any> {
        const headers = new HttpHeaders().set('Login-Origin', 'web');
        return this.http.get( fuseConfig.url + '/owner/unitHouses/', {headers: headers});
    }
    
    getBuildingSettings(id): Observable<any> {
        return this.http.get(fuseConfig.url + '/owner/buildingSettings/' + id);
    }

    getContacts(unit, contact): Observable<any> {
        const filter = {
            contact: contact
        };
        let search = '';
        let slice = false;
        if (filter.contact !== '') {
            search = '?filter=';
            slice = true;
        }
        if (filter.contact !== '') {
            search += `contact:eq:${filter.contact}|`;
        }

        if (slice === true) {
            search = search.slice(0, -1);
        }
        return this.http.get( fuseConfig.url + '/owner/getEmergencyContacts/' + unit + search);
    }

    addContact(body): Observable<any> {
        const data = {...body};
        data.img = data.img != null ? data.img.includes('data:image/png;base64') ? data.img.replace('data:image/png;base64,', '') : data.img.includes('data:image/jpeg;base64') ? data.img.replace('data:image/jpeg;base64,', '') : null : null;
        return this.http.post( fuseConfig.url + '/owner/addEmergencyContact', data);
    }

    updateContact(body): Observable<any> {
        const data = {...body};
        data.img = data.img != null ? data.img.includes('data:image/png;base64') ? data.img.replace('data:image/png;base64,', '') : data.img.includes('data:image/jpeg;base64') ? data.img.replace('data:image/jpeg;base64,', '') : null : null;
        return this.http.put( fuseConfig.url + '/owner/updateEmergencyContact', data);
    }

    deleteContact(contact_id): Observable<any> {
        return this.http.delete( fuseConfig.url + '/owner/deleteEmergencyContact/'+contact_id);
    }

    getCurrentInstruction(unit): Observable<any> {
        return this.http.get( fuseConfig.url + '/owner/getCurrentInstruction/' + unit);
    }

    postUnitInstruction(data): Observable<any> {
        return this.http.post( fuseConfig.url + '/owner/postUnitInstruction', data);
    }

    getVehicles(unit, resident, vehicle, user): Observable<any> {

        const filter = {
            vehicle: vehicle,
            user: user
        };
        let search = '';
        let slice = false;
        if (filter.vehicle !== '' || filter.user !== '') {
            search = '?filter=';
            slice = true;
        }
        if (filter.vehicle !== '') {
            search += `vehicle:eq:${filter.vehicle}|`;
        }
        if (filter.user !== '') {
            search += `user:eq:${filter.user}|`;
        }

        if (slice === true) {
            search = search.slice(0, -1);
        }

        return this.http.get( fuseConfig.url + '/owner/getUnitVehicles/' + unit + search);
    }

    addVehicle(body): Observable<any> {
        const data = { ...body };
        data.img = data.img != null ? data.img.includes('data:image/png;base64') ? data.img.replace('data:image/png;base64,', '') : data.img.includes('data:image/jpeg;base64') ? data.img.replace('data:image/jpeg;base64,', '') : null : null;
        return this.http.post(fuseConfig.url + '/owner/addUnitVehicle', data);
    }

    updateVehicle(body): Observable<any> {
        const data = { ...body };
        data.img = data.img != null ? data.img.includes('data:image/png;base64') ? data.img.replace('data:image/png;base64,', '') : data.img.includes('data:image/jpeg;base64') ? data.img.replace('data:image/jpeg;base64,', '') : null : null;
        return this.http.put(fuseConfig.url + '/owner/updateUnitVehicle', data);
    }

    deleteVehicle(vehicle_id): Observable<any> {
        return this.http.delete(fuseConfig.url + '/owner/deleteUnitVehicle/' + vehicle_id);
    }

    getPets(unit, pet): Observable<any> {
        const filter = {
            pet: pet
        };
        let search = '';
        let slice = false;
        if (filter.pet !== '') {
            search = '?filter=';
            slice = true;
        }
        if (filter.pet !== '') {
            search += `pet:eq:${filter.pet}|`;
        }

        if (slice === true) {
            search = search.slice(0, -1);
        }

        return this.http.get( fuseConfig.url + '/owner/getUnitPets/' + unit + search);
    }

    getNotificationRules(unit): Observable<any> {
        return this.http.get( fuseConfig.url + '/owner/notification_rules/' + unit);
    }

    updateNotificationRules(data): Observable<any> {
        return this.http.put( fuseConfig.url + '/owner/notification_rules', data);
    }

    getCommunityStaff(id): Observable<any> {
        return this.http.get( fuseConfig.url + '/owner/getCommunityStaff/' + id);
    }

    getPositions(): Observable<any> {
        return this.http.get( fuseConfig.url + '/shared/getBuildingPositions/');
    }

    getDashboard(unit): Observable<any> {
        return this.http.get( fuseConfig.url + '/owner/dashboard/' + unit);
    }

    getLocks(unit: string): Observable<{ locks: any[] }> {
        return this.http.get<{ locks: any[] }>(`${fuseConfig.url}/owner/units/${unit}/locks`);
    }

    getLockDetails(lock: string, filter = ""): Observable<{ codes: any[]; logs: any[] }> {
        return this.http.get<{ codes: any[]; logs: any[] }>(`${fuseConfig.url}/owner/locks/${lock}${filter}`);
    }

    openDoor(unit: string, lock): Observable<any> {
        return this.http.post(`${fuseConfig.url}/owner/units/${unit}/locks/${lock}/open`, {});
    }

    createCode(lock: string, code: any) {
        return this.http.post(`${fuseConfig.url}/owner/locks/${lock}/codes`, code);
    }

    deleteCode(lock: string, codes: string[]) {
        return this.http.put(`${fuseConfig.url}/owner/locks/${lock}/codes-multiple-delete`,{ codes });
    }

    checkSynced(lock: string, code: string) {
        return this.http.put(`${fuseConfig.url}/owner/locks/${lock}/codes/${code}`, {});
    }

    getGuestPhoto(guestId: string): Observable<any> {
        return this.http.get(`${fuseConfig.url}/owner/guests/photo/license/${guestId}`);
    }
}